import React, { useState } from 'react';

// Professional Support Widget with Home, Chat, and FAQ
const FloatingActionButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('percakapan');
    const [searchQuery, setSearchQuery] = useState('');

    const [openFaqIndex, setOpenFaqIndex] = useState(null);

    const faqs = [
        { 
            q: "Bagaimana cara melakukan pemesanan (Order)?", 
            a: "1. Pilih game yang ingin di top-up pada halaman utama.\n2. Masukkan ID Game (dan Server ID jika diperlukan) dengan teliti.\n3. Pilih nominal top-up yang Anda inginkan.\n4. Pilih metode pembayaran yang tersedia (QRIS, E-Wallet, VA).\n5. Masukkan nomor WhatsApp Anda (wajib).\n6. Klik tombol 'Beli Sekarang' dan selesaikan pembayaran sesuai instruksi.\n7. Top-up akan masuk secara otomatis dalam 1-5 menit!" 
        },
        {
            q: "Jam operasional layanan?",
            a: "Layanan top-up kami beroperasi secara otomatis 24 jam penuh. Namun, untuk layanan Customer Service (bantuan admin) aktif mulai pukul 09:00 hingga 20:00 WIB."
        }
    ];

    const filteredFaqs = faqs.filter(faq => 
        faq.q.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const waLink = "https://wa.me/628131091521?text=Halo%20Admin%2C%20saya%20ingin%20bertanya%20tentang%20Top%20Up...";

    return (
        <div className="support-widget-container">
            {isOpen && (
                <div className="support-window shadow-lg">
                    {/* Header */}
                    <div className="support-header">
                        <button className="close-support" onClick={() => setIsOpen(false)}>
                            <i className="bi bi-x-lg"></i>
                        </button>
                        <h4>Customer Support</h4>
                        <p>Hello, how may we help?</p>
                    </div>

                    {/* Content */}
                    <div className="support-content">
                        {activeTab === 'percakapan' && (
                            <div className="p-4 text-center">
                                <i className="bi bi-chat-dots text-success display-4 mb-3"></i>
                                <h5 className="fw-bold">Mulai Chat</h5>
                                <p className="text-muted small mb-4">Tim kami siap membantu Anda setiap hari pukul 09:00 - 20:00 WIB.</p>
                                <a href={waLink} target="_blank" rel="noreferrer" className="btn btn-success rounded-pill px-4">
                                    <i className="bi bi-whatsapp me-2"></i> Hubungi WhatsApp
                                </a>
                            </div>
                        )}

                        {activeTab === 'faq' && (
                            <div className="support-faq-tab">
                                <div className="faq-search-wrapper">
                                    <i className="bi bi-search"></i>
                                    <input 
                                        type="text" 
                                        className="faq-search-input" 
                                        placeholder="Cari T&J"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="faq-list">
                                    {filteredFaqs.length > 0 ? (
                                        filteredFaqs.map((faq, i) => (
                                            <div key={i} className="faq-item-container mb-2">
                                                <div 
                                                    className="faq-item" 
                                                    onClick={() => setOpenFaqIndex(openFaqIndex === i ? null : i)}
                                                    style={{ borderBottom: openFaqIndex === i ? 'none' : '' }}
                                                >
                                                    <span className="fw-medium">{faq.q}</span>
                                                    <i className={`bi bi-chevron-${openFaqIndex === i ? 'up' : 'down'} text-muted small`}></i>
                                                </div>
                                                {openFaqIndex === i && (
                                                    <div className="faq-answer p-3 bg-light rounded-bottom text-muted small" style={{ whiteSpace: 'pre-line' }}>
                                                        {faq.a}
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-center text-muted small">Tidak ditemukan hasil</p>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Footer / Tab Bar */}
                    <div className="support-tab-bar">

                        <button 
                            className={`support-tab-item ${activeTab === 'percakapan' ? 'active' : ''}`}
                            onClick={() => setActiveTab('percakapan')}
                        >
                            <i className={`bi bi-chat${activeTab === 'percakapan' ? '-fill' : ''}`}></i>
                            <span>Percakapan</span>
                        </button>
                        <button 
                            className={`support-tab-item ${activeTab === 'faq' ? 'active' : ''}`}
                            onClick={() => setActiveTab('faq')}
                        >
                            <i className={`bi bi-question-circle${activeTab === 'faq' ? '-fill' : ''}`}></i>
                            <span>Tanya jawab</span>
                        </button>
                    </div>
                </div>
            )}

            {/* Trigger FAB */}
            <div 
                className="fab" 
                style={{ backgroundColor: isOpen ? '#dc3545' : '#25D366' }}
                onClick={() => setIsOpen(!isOpen)}
            >
                {isOpen ? (
                    <i className="bi bi-x-lg" style={{ fontSize: '24px', color: '#FFF' }}></i>
                ) : (
                    <i className="bi bi-chat-text-fill" style={{ fontSize: '28px', color: '#FFF' }}></i>
                )}
            </div>
        </div>
    );
};

export default FloatingActionButton;
